import React, {useRef, useState} from 'react';
import {Card, CardContent} from "@/components/ui/card";
import {Label} from "@/components/ui/label";
import {Button, Divider, Input} from "antd";
import {toast} from "react-toastify";
import {useApiAuthOtp} from "@/api/auth";

import {formatMobileNumber} from "@/lib/utils/number";
import AuthCardHeaderSection from "@/pages/auth/_section/AuthCardHeaderSection";
import {AuthFooterLinkNewMobileSection} from "@/pages/auth/_section/AuthFooterLinkNewMobileSection";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
import {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";


function StateRegisterSection({myMobile, changeMyState, setMyMobile, setMyData}) {
    const [step, setStep] = useState('register')
    const [myOtpToken, setMyOtpToken] = useState('')

    const [myDisplayName, setMyDisplayName] = useState('')
    const [myPassword, setMyPassword] = useState('')
    let mobileRef = useRef(null);

    let rePasswordRef = useRef(null);
    let displayNameRef = useRef(null);
    let passwordRef = useRef(null);

    const {mutate: AuthOTP, isPending} = useApiAuthOtp()


    function submitForm() {

        if (!myMobile) {
            toast.error('لطفا تلفن همراه خود را وارد کنید')
            mobileRef.current.focus()
            return;
        }


        if (!passwordRef.current.input.value) {
            toast.error('لطفا کلمه عبور خود را وارد کنید')
            passwordRef.current.focus()
            return;
        }
        if (!rePasswordRef.current.input.value) {
            toast.error('لطفا تکرار کلمه عبور خود را وارد کنید')
            passwordRef.current.focus()
            return;
        }

        if (passwordRef.current.input.value !== rePasswordRef.current.input.value) {
            toast.error('کلمه عبور و تکرار کلمه عبور باهم برابر نیستند')
            rePasswordRef.current.focus()
            return;
        }


        if (passwordRef.current.input.value.length < 8) {
            toast.error('کلمه عبور باید حداقل ۸ کاراکتر باشد')
            rePasswordRef.current.focus()
            return;
        }


        AuthOTP({mobile: formatMobileNumber(myMobile)}, {
            onSuccess: (data) => {
                setMyData({
                    otpToken: data?.data?.data?.otp_token,
                    displayName: displayNameRef.current.input.value,
                    password: passwordRef.current.input.value,
                    callFrom: 'register',
                })
                changeMyState('otp')
            }, onError: (error) => {
                ApiHandleErrorMessage(error);
            }
        })
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            submitForm()
        }
    };

    return (
        <Card>
            <AuthCardHeaderSection title={'ثبت‌نام در سامانه'}
                                   description={'برای ثبت‌نام لطفا اطلاعات زیر را با دقت تکمیل کنید'}/>

            <CardContent>

                <div className="flex flex-col gap-6">

                    <div className="grid gap-2">
                        <div className="flex items-center">
                            <Label htmlFor="displayname">نام</Label>

                        </div>
                        <Input
                            ref={displayNameRef}

                            id="displayname" type="text" required/>
                    </div>
                    <div className="grid gap-2">
                        <div className="flex items-center">
                            <Label htmlFor="password">کلمه عبور</Label>

                        </div>
                        <Input.Password
                            onKeyDown={handleKeyDown}
                            iconRender={(visible) => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}
                            ref={passwordRef}
                            id="password" type="password" required/>
                    </div>

                    <div className="grid gap-2">
                        <div className="flex items-center">
                            <Label htmlFor="repassword">تکرار کلمه عبور</Label>

                        </div>
                        <Input.Password
                            onKeyDown={handleKeyDown}
                            iconRender={(visible) => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}
                            ref={rePasswordRef}
                            id="repassword" type="password" required/>
                    </div>
                    <Button
                        loading={isPending}
                        onClick={() => submitForm()}
                        type="primary" className="w-full">
                        ثبت نام
                    </Button>

                </div>
                <Divider type={'vertical'}/>
                <AuthFooterLinkNewMobileSection myMobile={myMobile} changeMyState={changeMyState}/>

            </CardContent>
        </Card>
    );

}

export default StateRegisterSection;